const jobs = [
    {
        title: "01. Paystack (A Stripe Company), February 2023 - May 2025",
        link: "https://paystack.com",
        description: "I worked as a software engineer at Paystack, building financial products to power payments across Africa."
    },
    {
        title: "02. Allawee (ODX 1), February 2022 - February 2023",
        link: "https://allawee.com/",
        description: "I was a software and documentation engineer, working on a variety of projects across lending, expense management, and cards issuing."
    },
]

export default jobs